function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "icon-user-clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  width: 13,
  height: 16,
  fill: "fill"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#icon-user-clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M31.777,9.768A4.884,4.884,0,1,1,36.6,4.884a4.86,4.86,0,0,1-4.825,4.884m0-8.563a3.679,3.679,0,1,0,3.634,3.679,3.661,3.661,0,0,0-3.634-3.679",
  transform: "translate(-25.348)",
  fill: "fill"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.4,179.063a.6.6,0,0,1-.6-.6,3,3,0,0,0-1.083-2.059,5.937,5.937,0,0,0-4.189-1.678H6.462A5.937,5.937,0,0,0,2.273,176.4,3,3,0,0,0,1.19,178.46a.6.6,0,0,1-.6.6.6.6,0,0,1-.6-.6,4.14,4.14,0,0,1,1.445-2.925,7.114,7.114,0,0,1,5.017-2.018h.075a7.114,7.114,0,0,1,5.017,2.018A4.14,4.14,0,0,1,13,178.46a.6.6,0,0,1-.6.6",
  transform: "translate(0 -163.063)",
  fill: "fill"
}));

function SvgIconUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/icon_user.b046e182.svg";
export { ForwardRef as ReactComponent };